<template>
  <div class="app-main-content  mailing-address">
    <div class="grid-view">
      <div class="main-content">
        <div class="section">
          <div class="filters">
            <el-form :inline="true" label-width="88px" label-position="left">
              <div class="el-form-item-wrapper">
                <el-form-item :label="$t('baseInfo.mailingAddress.office')">
                  <el-select v-model="searchConditions.officeId" style="width: 170px;">
                    <el-option
                      v-for="office in currentOfficeList"
                      :key="office.uuid"
                      :value="office.officeId"
                      :label="office.code"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('baseInfo.mailingAddress.lobType')">
                  <el-select
                    v-model="searchConditions.lob"
                    :placeholder="$t('common.tips.pleaseChoose')"
                    clearable
                    style="width: 170px;"
                    @change="changeLob('searchFormDisable', $event)"
                  >
                    <el-option
                      v-for="item in itemTypeArray"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('baseInfo.mailingAddress.partner')">
                  <cargo-advance-select
                    :select-type="selectTypeNames.basic_data_Company"
                    filterable
                    :callback-params="{key:'partnerId'}"
                    callback-method-type="value"
                    :default-value="searchConditions.partnerId"
                    style="width:170px;"
                    @parentCallBack="getValueFromChild(searchConditions, $event)"
                  />
                </el-form-item>
                <el-form-item :label="$t('baseInfo.mailingAddress.podName')">
                  <cargo-advance-select
                    v-if="['AE', 'AI'].indexOf(searchConditions.lob) !== -1"
                    :key="2"
                    :disabled="podSelectOpt.searchFormDisable"
                    filterable
                    :select-type="selectTypeNames.basic_data_Airport"
                    :headers="['CODE',$t('Information.EnglishName2')]"
                    :fields="['code','englishName']"
                    :callback-params="{key:'pod'}"
                    callback-method-type="value"
                    :default-value="searchConditions.pod"
                    tag-name="englishName"
                    style="width: 170px;"
                    @parentCallBack="getValueFromChild(searchConditions, $event)"
                  />
                  <cargo-advance-select
                    v-else
                    :key="1"
                    :disabled="podSelectOpt.searchFormDisable"
                    :select-type="selectTypeNames.basic_data_Seaport"
                    filterable
                    :headers="['CODE',$t('Information.EnglishName2')]"
                    :fields="['code','englishName']"
                    :callback-params="{key:'pod'}"
                    callback-method-type="value"
                    tag-name="englishName"
                    :default-value="searchConditions.pod"
                    style="width:170px;"
                    @parentCallBack="getValueFromChild(searchConditions, $event)"
                  />
                </el-form-item>
              </div>
              <div class="el-form-item-wrapper">
                <el-form-item :label="$t('baseInfo.mailingAddress.shipperCode')">
                  <el-input
                    v-model="searchConditions.shipperCode"
                  />
                </el-form-item>
                <el-form-item :label="$t('baseInfo.mailingAddress.consigneeCode')">
                  <el-input
                    v-model="searchConditions.consigneeCode"
                  />
                </el-form-item>
                <el-form-item :label="$t('baseInfo.mailingAddress.notifyCode')">
                  <el-input
                    v-model="searchConditions.notifyCode"
                  />
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_PaymentCode')">
                  <el-input
                    v-model="searchConditions.paymentCode"
                  />
                </el-form-item>
              </div>
              <div class="el-form-item-wrapper">
                <el-form-item :label="$t('baseInfo.mailingAddress.shipperName')">
                  <el-input
                    v-model="searchConditions.shipperName"
                  />
                </el-form-item>
                <el-form-item :label="$t('baseInfo.mailingAddress.consigneeName')">
                  <el-input
                    v-model="searchConditions.consigneeName"
                  />
                </el-form-item>
                <el-form-item :label="$t('baseInfo.mailingAddress.notifyName')">
                  <el-input
                    v-model="searchConditions.notifyName"
                  />
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_PaymentName')">
                  <el-input
                    v-model="searchConditions.paymentName"
                  />
                </el-form-item>
              </div>
            </el-form>
          </div>
          <div class="app-main-inner-row">
            <div class="triggers">
              <el-button type="primary" size="mini" @click="fetchMailingAddressList">{{ $t('common.btn.query') }}</el-button>
              <el-button type="primary" @click="popMailingAddressAddDialog">{{ $t('common.btn.new') }}</el-button>
              <el-button type="primary" @click="popMailingAddressEditDialog">{{ $t('common.btn.edit') }}</el-button>
              <el-button type="danger" @click="toBatchDel">{{ $t('common.btn.delete') }}</el-button>
              <cargo-grid-state-btn :grid-params="gridParams" config-module="100801" />
            </div>
          </div>
        </div>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="100801"
            :wrap-text="true"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            v-show="searchConditions.total>0"
            :total="searchConditions.total"
            :page.sync="searchConditions.pageNum"
            :limit.sync="searchConditions.pageSize"
            @pagination="fetchMailingAddressList"
          />
        </div>
      </div>
    </div>
    <!-- 添加收发通地址 -->
    <el-dialog
      v-if="mailingAddressMaintainDialog.isShow"
      v-el-drag-dialog
      :visible.sync="mailingAddressMaintainDialog.isShow"
      :close-on-click-modal="false"
      :title="mailingAddressMaintainDialog.title"
      width="1500px"
    >
      <el-scrollbar style="height: 100%;">
        <div class="app-main-inner-row">
          <el-form ref="mailingAddressAddForm" :model="mailingAddressForm" :inline="true" label-width="100px" label-position="left">
            <div class="el-form-item-wrapper">
              <el-form-item :label="$t('baseInfo.mailingAddress.lobType')">
                <el-select
                  v-model="mailingAddressForm.lob"
                  :placeholder="$t('common.tips.pleaseChoose')"
                  clearable
                  style="width: 170px;"
                  @change="changeLob('maintainFormDisable', $event)"
                >
                  <el-option
                    v-for="item in itemTypeArray"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('baseInfo.mailingAddress.partner1')">
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_Company"
                  filterable
                  :callback-params="{key:'partnerId'}"
                  callback-method-type="value"
                  :default-value="mailingAddressForm.partnerId"
                  style="width:170px;"
                  @parentCallBack="getValueFromChild(mailingAddressForm, $event)"
                />
              </el-form-item>
              <el-form-item :label="$t('baseInfo.mailingAddress.pod1')">
                <cargo-advance-select
                  v-if="['AE', 'AI'].indexOf(mailingAddressForm.lob) !== -1"
                  :key="2"
                  :disabled="podSelectOpt.searchFormDisable"
                  filterable
                  :select-type="selectTypeNames.basic_data_Airport"
                  :callback-params="{key:'pod'}"
                  callback-method-type="value"
                  :default-value="mailingAddressForm.pod"
                  style="width: 170px;"
                  @parentCallBack="getValueFromChild(mailingAddressForm, $event)"
                />
                <cargo-advance-select
                  v-else
                  :key="1"
                  :disabled="podSelectOpt.searchFormDisable"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  filterable
                  :callback-params="{key:'pod'}"
                  callback-method-type="value"
                  :default-value="mailingAddressForm.pod"
                  style="width:170px;"
                  @parentCallBack="getValueFromChild(mailingAddressForm, $event)"
                />
              </el-form-item>
              <el-form-item :label="$t('baseInfo.mailingAddress.shipperCode')" prop="shipperCode">
                <el-input v-model="mailingAddressForm.shipperCode" />
              </el-form-item>
              <el-form-item :label="$t('baseInfo.mailingAddress.consigneeCode')" prop="consigneeCode">
                <el-input v-model="mailingAddressForm.consigneeCode" />
              </el-form-item>
              <el-form-item :label="$t('baseInfo.mailingAddress.notifyCode')" prop="notifyCode">
                <el-input v-model="mailingAddressForm.notifyCode" />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_PaymentCode')" prop="paymentCode">
                <el-input v-model="mailingAddressForm.paymentCode" />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.DestinationAgent')" prop="destinationAgent">
                <cargo-advance-select
                  no="destinationAgent"
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{overseaAgent:true,companyLob:'seaExport',active:true}"
                  :default-value="mailingAddressForm.destinationAgent"
                  filterable
                  :headers="[$t('Partners.englishName')]"
                  :fields="['englishName']"
                  tag-name="englishName"
                  :callback-params="{key:'destinationAgent'}"
                  callback-method-type="value"
                  style="width:170px;"
                  @parentCallBack="getValueFromChild(mailingAddressForm, $event)"
                />
              </el-form-item>
            </div>
          </el-form>
        </div>
        <!--    格式化舱单信息按钮    -->
        <div class="app-main-inner-row">
          <el-button type="primary" size="mini" @click="formatManifestInfo = !formatManifestInfo">
            {{ $t('baseInfo.mailingAddress.formatManifestInfo') }}
            <i class="el-icon-caret-bottom el-icon--right" />
          </el-button>
        </div>
        <div class="app-main-inner-row">
          <el-form v-model="mailingAddressForm" :inline="true" :label-width="'130px'" label-position="left" style="height:300px;min-height:300px;">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-tag size="medium" class="tag-w">{{ $t('baseInfo.mailingAddress.shipper') }}</el-tag>
                <div class="el-form-item-wrapper el-form-item-group">
                  <div v-show="!formatManifestInfo" :style="{ position: 'relative', height: $selectByLang('750px', '750px', '750px', '950px', '1000px', '950px') }">
                    <el-form-item>
                      <line-label slot="label" :label="$t('baseInfo.mailingAddress.shipperEnterpriseCode')" />
                      <cargo-input v-model="mailingAddressForm.shipperShortCode" :auto-uppercase="notUppercaseShipperConsigneNotify" :placeholder="$t('baseInfo.mailingAddress.shortCode')" />
                    </el-form-item>
                    <el-form-item label=" ">
                      <cargo-input v-model="mailingAddressForm.shipperEnterpriseCode" :auto-uppercase="notUppercaseShipperConsigneNotify" class="prefix-input" :placeholder="$t('baseInfo.mailingAddress.enterpriseCode')" />
                    </el-form-item>
                    <el-form-item>
                      <line-label slot="label" :label="$t('baseInfo.mailingAddress.shipperEnterpriseName')" />
                      <cargo-input v-model="mailingAddressForm.shipperEnterpriseName" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.shipperAddress')">
                      <cargo-input v-model="mailingAddressForm.shipperAddress" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item>
                      <el-select v-model="mailingAddressForm.shipperContactsType" style="width:130px;">
                        <el-option
                          v-for="item in mailingAddressMaintainDialog.contactType.shipperContactsTypes"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                      <cargo-input v-model="mailingAddressForm.shipperContacts" :auto-uppercase="notUppercaseShipperConsigneNotify" style="width: 135px;" />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.cityName')">
                      <cargo-input v-model="mailingAddressForm.shipperCityName" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.provinceCode')">
                      <cargo-input v-model="mailingAddressForm.shipperProvinceCode" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.provinceName')">
                      <cargo-input v-model="mailingAddressForm.shipperProvinceName" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.zipCode')">
                      <cargo-input v-model="mailingAddressForm.shipperZipCode" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_CountryRegionCode')">
                      <cargo-input v-model="mailingAddressForm.shipperCountryCode" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.aeoEnterpriseCode')">
                      <cargo-input v-model="mailingAddressForm.shipperAeoEnterpriseCode" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item label="EORI">
                      <cargo-input v-model="mailingAddressForm.shipperEori" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item :label="$t('SeaExport.StreetNumber')">
                      <cargo-input v-model="mailingAddressForm.shipperStreetNo" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item label="VIP CODE">
                      <cargo-input v-model="mailingAddressForm.shipperVipCode" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item label="MSC CODE">
                      <cargo-input v-model="mailingAddressForm.shipperMscCode" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item label="COMPANY CODE">
                      <cargo-input v-model="mailingAddressForm.shipperCompanyCode" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item label="INTTRA CODE">
                      <cargo-input v-model="mailingAddressForm.shipperInttraCode" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <div class="float-btn-wrapper">
                      <el-button type="info" @click="syncFormatInfoToOrder('shipper')">{{ $t('baseInfo.mailingAddress.syncFormatInfoToOrder') }}</el-button>
                    </div>
                  </div>
                  <div class="el-form-item-wrapper">
                    <el-form-item>
                      <cargo-input v-model="mailingAddressForm.shipperLine1" :auto-uppercase="notUppercaseShipperConsigneNotify" class="input-w" @dblclick.native="popRowDataEditor('shipper')" />
                    </el-form-item>
                    <el-form-item>
                      <cargo-input v-model="mailingAddressForm.shipperLine2" :auto-uppercase="notUppercaseShipperConsigneNotify" class="input-w" @dblclick.native="popRowDataEditor('shipper')" />
                    </el-form-item>
                    <el-form-item>
                      <cargo-input v-model="mailingAddressForm.shipperLine3" :auto-uppercase="notUppercaseShipperConsigneNotify" class="input-w" @dblclick.native="popRowDataEditor('shipper')" />
                    </el-form-item>
                    <el-form-item>
                      <cargo-input v-model="mailingAddressForm.shipperLine4" :auto-uppercase="notUppercaseShipperConsigneNotify" class="input-w" @dblclick.native="popRowDataEditor('shipper')" />
                    </el-form-item>
                    <el-form-item>
                      <cargo-input v-model="mailingAddressForm.shipperLine5" :auto-uppercase="notUppercaseShipperConsigneNotify" class="input-w" @dblclick.native="popRowDataEditor('shipper')" />
                    </el-form-item>
                    <el-form-item>
                      <cargo-input v-model="mailingAddressForm.shipperLine6" :auto-uppercase="notUppercaseShipperConsigneNotify" class="input-w" @dblclick.native="popRowDataEditor('shipper')" />
                    </el-form-item>
                  </div>
                </div>
              </el-col>
              <el-col :span="6">
                <el-tag size="medium" class="tag-w">{{ $t('baseInfo.mailingAddress.consignee') }}</el-tag>
                <div class="el-form-item-wrapper el-form-item-group">
                  <div v-show="!formatManifestInfo" :style="{ position: 'relative', height: $selectByLang('750px', '750px', '750px', '950px', '1000px', '950px') }">
                    <el-form-item label=" ">
                      <el-checkbox v-model="mailingAddressForm.instructBill" :label="$t('baseInfo.mailingAddress.instructBill')" @change="ladingBill" />
                    </el-form-item>
                    <el-form-item>
                      <line-label slot="label" :label="$t('baseInfo.mailingAddress.consigneeEnterpriseCode')" />
                      <cargo-input v-model="mailingAddressForm.consigneeShortCode" :auto-uppercase="notUppercaseShipperConsigneNotify" :placeholder="$t('baseInfo.mailingAddress.shortCode')" />
                    </el-form-item>
                    <el-form-item label=" ">
                      <cargo-input v-model="mailingAddressForm.consigneeEnterpriseCode" :auto-uppercase="notUppercaseShipperConsigneNotify" class="prefix-input" :placeholder="$t('baseInfo.mailingAddress.enterpriseCode')" />
                    </el-form-item>
                    <el-form-item>
                      <line-label slot="label" :label="$t('baseInfo.mailingAddress.consigneeEnterpriseName')" />
                      <cargo-input v-model="mailingAddressForm.consigneeEnterpriseName" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.consigneeAddress')">
                      <cargo-input v-model="mailingAddressForm.consigneeAddress" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item>
                      <el-select v-model="mailingAddressForm.consigneeContactsType" style="width:130px;">
                        <el-option
                          v-for="item in mailingAddressMaintainDialog.contactType.consigneeContactsTypes"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                      <cargo-input v-model="mailingAddressForm.consigneeContacts" :auto-uppercase="notUppercaseShipperConsigneNotify" style="width: 135px;" />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.cityName')">
                      <cargo-input v-model="mailingAddressForm.consigneeCityName" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.provinceCode')">
                      <cargo-input v-model="mailingAddressForm.consigneeProvinceCode" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.provinceName')">
                      <cargo-input v-model="mailingAddressForm.consigneeProvinceName" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.zipCode')">
                      <cargo-input v-model="mailingAddressForm.consigneeZipCode" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_CountryRegionCode')">
                      <cargo-input v-model="mailingAddressForm.consigneeCountryCode" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.aeoEnterpriseCode')">
                      <cargo-input v-model="mailingAddressForm.consigneeAeoEnterpriseCode" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item>
                      <line-label slot="label" :label="$t('baseInfo.mailingAddress.consigneeSpecificContactsName')" />
                      <cargo-input v-model="mailingAddressForm.consigneeSpecificContactsName" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item label="EORI">
                      <cargo-input v-model="mailingAddressForm.consigneeEori" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item :label="$t('SeaExport.StreetNumber')">
                      <cargo-input v-model="mailingAddressForm.consigneeStreetNo" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item label="VIP CODE">
                      <cargo-input v-model="mailingAddressForm.consigneeVipCode" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item label="MSC CODE">
                      <cargo-input v-model="mailingAddressForm.consigneeMscCode" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item label="COMPANY CODE">
                      <cargo-input v-model="mailingAddressForm.consigneeCompanyCode" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item label="INTTRA CODE">
                      <cargo-input v-model="mailingAddressForm.consigneeInttraCode" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item>
                      <el-select v-model="mailingAddressForm.consigneeSpecificContactsType" style="width:130px;">
                        <el-option
                          v-for="item in mailingAddressMaintainDialog.contactType.consigneeSpecificContactsTypes"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                      <cargo-input v-model="mailingAddressForm.consigneeSpecificContacts" :auto-uppercase="notUppercaseShipperConsigneNotify" style="width: 135px;" />
                    </el-form-item>
                    <div class="float-btn-wrapper">
                      <el-button type="info" @click="syncFormatInfoToOrder('consignee')">{{ $t('baseInfo.mailingAddress.syncFormatInfoToOrder') }}</el-button>
                    </div>
                  </div>
                  <div class="el-form-item-wrapper">
                    <el-form-item>
                      <cargo-input v-model="mailingAddressForm.consigneeLine1" :auto-uppercase="notUppercaseShipperConsigneNotify" class="input-w" @dblclick.native="popRowDataEditor('consignee')" />
                    </el-form-item>
                    <el-form-item>
                      <cargo-input v-model="mailingAddressForm.consigneeLine2" :auto-uppercase="notUppercaseShipperConsigneNotify" class="input-w" @dblclick.native="popRowDataEditor('consignee')" />
                    </el-form-item>
                    <el-form-item>
                      <cargo-input v-model="mailingAddressForm.consigneeLine3" :auto-uppercase="notUppercaseShipperConsigneNotify" class="input-w" @dblclick.native="popRowDataEditor('consignee')" />
                    </el-form-item>
                    <el-form-item>
                      <cargo-input v-model="mailingAddressForm.consigneeLine4" :auto-uppercase="notUppercaseShipperConsigneNotify" class="input-w" @dblclick.native="popRowDataEditor('consignee')" />
                    </el-form-item>
                    <el-form-item>
                      <cargo-input v-model="mailingAddressForm.consigneeLine5" :auto-uppercase="notUppercaseShipperConsigneNotify" class="input-w" @dblclick.native="popRowDataEditor('consignee')" />
                    </el-form-item>
                    <el-form-item>
                      <cargo-input v-model="mailingAddressForm.consigneeLine6" :auto-uppercase="notUppercaseShipperConsigneNotify" class="input-w" @dblclick.native="popRowDataEditor('consignee')" />
                    </el-form-item>
                  </div>
                </div>
              </el-col>
              <el-col :span="6">
                <el-tag size="medium" class="tag-w">{{ $t('baseInfo.mailingAddress.notify') }}</el-tag>
                <div class="el-form-item-wrapper el-form-item-group">
                  <div v-show="!formatManifestInfo" :style="{ position: 'relative', height: $selectByLang('750px', '750px', '750px', '950px', '1000px', '950px') }">
                    <el-form-item>
                      <line-label slot="label" :label="$t('baseInfo.mailingAddress.notifyEnterpriseCode')" />
                      <cargo-input v-model="mailingAddressForm.notifyShortCode" :auto-uppercase="notUppercaseShipperConsigneNotify" :placeholder="$t('baseInfo.mailingAddress.shortCode')" />
                    </el-form-item>
                    <el-form-item label=" ">
                      <cargo-input v-model="mailingAddressForm.notifyEnterpriseCode" :auto-uppercase="notUppercaseShipperConsigneNotify" class="prefix-input" :placeholder="$t('baseInfo.mailingAddress.enterpriseCode')" />
                    </el-form-item>
                    <el-form-item>
                      <line-label slot="label" :label="$t('baseInfo.mailingAddress.notifyEnterpriseName')" />
                      <cargo-input v-model="mailingAddressForm.notifyEnterpriseName" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.notifyAddress')">
                      <cargo-input v-model="mailingAddressForm.notifyAddress" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item>
                      <el-select v-model="mailingAddressForm.notifyContactsType" style="width:130px;">
                        <el-option
                          v-for="item in mailingAddressMaintainDialog.contactType.notifyContactsTypes"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                      <cargo-input v-model="mailingAddressForm.notifyContacts" :auto-uppercase="notUppercaseShipperConsigneNotify" style="width: 135px;" />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.cityName')">
                      <cargo-input v-model="mailingAddressForm.notifyCityName" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.provinceCode')">
                      <cargo-input v-model="mailingAddressForm.notifyProvinceCode" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.provinceName')">
                      <cargo-input v-model="mailingAddressForm.notifyProvinceName" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.zipCode')">
                      <cargo-input v-model="mailingAddressForm.notifyZipCode" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_CountryRegionCode')">
                      <cargo-input v-model="mailingAddressForm.notifyCountryCode" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.aeoEnterpriseCode')">
                      <cargo-input v-model="mailingAddressForm.notifyAeoEnterpriseCode" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <div class="float-btn-wrapper">
                      <el-button type="info" @click="syncFormatInfoToOrder('notify')">{{ $t('baseInfo.mailingAddress.syncFormatInfoToOrder') }}</el-button>
                    </div>
                    <el-form-item label="EORI">
                      <cargo-input v-model="mailingAddressForm.notifyEori" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item :label="$t('SeaExport.StreetNumber')">
                      <cargo-input v-model="mailingAddressForm.notifyStreetNo" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item label="VIP CODE">
                      <cargo-input v-model="mailingAddressForm.notifyVipCode" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item label="MSC CODE">
                      <cargo-input v-model="mailingAddressForm.notifyMscCode" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item label="COMPANY CODE">
                      <cargo-input v-model="mailingAddressForm.notifyCompanyCode" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                    <el-form-item label="INTTRA CODE">
                      <cargo-input v-model="mailingAddressForm.notifyInttraCode" :auto-uppercase="notUppercaseShipperConsigneNotify" />
                    </el-form-item>
                  </div>
                  <div class="el-form-item-wrapper">
                    <el-form-item>
                      <cargo-input v-model="mailingAddressForm.notifyLine1" :auto-uppercase="notUppercaseShipperConsigneNotify" class="input-w" @dblclick.native="popRowDataEditor('notify')" />
                    </el-form-item>
                    <el-form-item>
                      <cargo-input v-model="mailingAddressForm.notifyLine2" :auto-uppercase="notUppercaseShipperConsigneNotify" class="input-w" @dblclick.native="popRowDataEditor('notify')" />
                    </el-form-item>
                    <el-form-item>
                      <cargo-input v-model="mailingAddressForm.notifyLine3" :auto-uppercase="notUppercaseShipperConsigneNotify" class="input-w" @dblclick.native="popRowDataEditor('notify')" />
                    </el-form-item>
                    <el-form-item>
                      <cargo-input v-model="mailingAddressForm.notifyLine4" :auto-uppercase="notUppercaseShipperConsigneNotify" class="input-w" @dblclick.native="popRowDataEditor('notify')" />
                    </el-form-item>
                    <el-form-item>
                      <cargo-input v-model="mailingAddressForm.notifyLine5" :auto-uppercase="notUppercaseShipperConsigneNotify" class="input-w" @dblclick.native="popRowDataEditor('notify')" />
                    </el-form-item>
                    <el-form-item>
                      <cargo-input v-model="mailingAddressForm.notifyLine6" :auto-uppercase="notUppercaseShipperConsigneNotify" class="input-w" @dblclick.native="popRowDataEditor('notify')" />
                    </el-form-item>
                  </div>
                </div>
              </el-col>
              <!--付款方代码-->
              <el-col :span="6">
                <el-tag size="medium" class="tag-w">{{ $t('CargoMsg.Cargo_Payment1') }}</el-tag>
                <div class="el-form-item-wrapper el-form-item-group">
                  <div v-show="!formatManifestInfo" :style="{ position: 'relative', height: $selectByLang('750px', '750px', '750px', '950px', '1000px', '950px') }">
                    <el-form-item label=" ">
                      <el-checkbox v-model="mailingAddressForm.paymentInstructBill" :label="$t('baseInfo.mailingAddress.instructBill')" @change="ladingPaymentBill" />
                    </el-form-item>
                    <el-form-item>
                      <line-label slot="label" :label="$t('CargoMsg.Cargo_PaymentEnterpriseCode')" />
                      <el-input v-model="mailingAddressForm.paymentShortCode" v-uppercase :placeholder="$t('baseInfo.mailingAddress.shortCode')" />
                    </el-form-item>
                    <el-form-item label=" ">
                      <el-input v-model="mailingAddressForm.paymentEnterpriseCode" v-uppercase class="prefix-input" :placeholder="$t('CargoMsg.Cargo_PaymentEnterpriseCode')" />
                    </el-form-item>
                    <el-form-item>
                      <line-label slot="label" :label="$t('CargoMsg.Cargo_Payment2')" />
                      <el-input v-model="mailingAddressForm.paymentEnterpriseName" v-uppercase />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_Payment3')">
                      <el-input v-model="mailingAddressForm.paymentAddress" v-uppercase />
                    </el-form-item>
                    <el-form-item>
                      <el-select v-model="mailingAddressForm.paymentContactsType" style="width:130px;">
                        <el-option
                          v-for="item in mailingAddressMaintainDialog.contactType.paymentContactsTypes"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                      <el-input v-model="mailingAddressForm.paymentContacts" v-uppercase style="width: 135px;" />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.cityName')">
                      <el-input v-model="mailingAddressForm.paymentCityName" v-uppercase />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.provinceCode')">
                      <el-input v-model="mailingAddressForm.paymentProvinceCode" v-uppercase />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.provinceName')">
                      <el-input v-model="mailingAddressForm.paymentProvinceName" v-uppercase />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.zipCode')">
                      <el-input v-model="mailingAddressForm.paymentZipCode" v-uppercase />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_CountryRegionCode')">
                      <el-input v-model="mailingAddressForm.paymentCountryCode" v-uppercase />
                    </el-form-item>
                    <el-form-item :label="$t('baseInfo.mailingAddress.aeoEnterpriseCode')">
                      <el-input v-model="mailingAddressForm.paymentAeoEnterpriseCode" v-uppercase />
                    </el-form-item>
                    <el-form-item>
                      <line-label slot="label" :label="$t('baseInfo.mailingAddress.consigneeSpecificContactsName')" />
                      <el-input v-model="mailingAddressForm.paymentSpecificContactsName" v-uppercase />
                    </el-form-item>
                    <el-form-item label="EORI">
                      <el-input v-model="mailingAddressForm.paymentEori" v-uppercase />
                    </el-form-item>
                    <el-form-item :label="$t('SeaExport.StreetNumber')">
                      <el-input v-model="mailingAddressForm.paymentStreetNo" v-uppercase />
                    </el-form-item>
                    <el-form-item label="VIP CODE">
                      <cargo-input v-model="mailingAddressForm.paymentVipCode" v-uppercase />
                    </el-form-item>
                    <el-form-item label="MSC CODE">
                      <cargo-input v-model="mailingAddressForm.paymentMscCode" v-uppercase />
                    </el-form-item>
                    <el-form-item label="COMPANY CODE">
                      <cargo-input v-model="mailingAddressForm.paymentCompanyCode" v-uppercase />
                    </el-form-item>
                    <el-form-item label="INTTRA CODE">
                      <cargo-input v-model="mailingAddressForm.paymentInttraCode" v-uppercase />
                    </el-form-item>
                    <el-form-item>
                      <el-select v-model="mailingAddressForm.paymentSpecificContactsType" style="width:130px;">
                        <el-option
                          v-for="item in mailingAddressMaintainDialog.contactType.paymentSpecificContactsTypes"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                      <el-input v-model="mailingAddressForm.paymentSpecificContacts" v-uppercase style="width: 135px;" />
                    </el-form-item>
                    <div class="float-btn-wrapper">
                      <el-button type="info" @click="syncFormatInfoToOrder('payment')">{{ $t('baseInfo.mailingAddress.syncFormatInfoToOrder') }}</el-button>
                    </div>
                  </div>
                  <div class="el-form-item-wrapper">
                    <el-form-item>
                      <el-input v-model="mailingAddressForm.paymentLine1" v-uppercase class="input-w" @dblclick.native="popRowDataEditor('payment')" />
                    </el-form-item>
                    <el-form-item>
                      <el-input v-model="mailingAddressForm.paymentLine2" v-uppercase class="input-w" @dblclick.native="popRowDataEditor('payment')" />
                    </el-form-item>
                    <el-form-item>
                      <el-input v-model="mailingAddressForm.paymentLine3" v-uppercase class="input-w" @dblclick.native="popRowDataEditor('payment')" />
                    </el-form-item>
                    <el-form-item>
                      <el-input v-model="mailingAddressForm.paymentLine4" v-uppercase class="input-w" @dblclick.native="popRowDataEditor('payment')" />
                    </el-form-item>
                    <el-form-item>
                      <el-input v-model="mailingAddressForm.paymentLine5" v-uppercase class="input-w" @dblclick.native="popRowDataEditor('payment')" />
                    </el-form-item>
                    <el-form-item>
                      <el-input v-model="mailingAddressForm.paymentLine6" v-uppercase class="input-w" @dblclick.native="popRowDataEditor('payment')" />
                    </el-form-item>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-scrollbar>
      <div slot="footer">
        <el-button type="primary" @click="submitMailingAddress">{{ $t('common.btn.save') }}</el-button>
        <el-button @click="cancelSaveOrEdit">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
    <!--  收发通地址维护弹窗信息行双击弹窗  -->
    <el-dialog
      v-if="maintainDataRowPopEditor.isShow"
      v-el-drag-dialog
      :visible.sync="maintainDataRowPopEditor.isShow"
      :title="maintainDataRowPopEditor.title"
      top="30vh"
    >
      <div class="app-main-inner-row">
        <cargo-input v-model="maintainDataRowPopEditor.textData" :auto-uppercase="notUppercaseShipperConsigneNotify" rows="6" type="textarea" />
      </div>
      <div slot="footer">
        <el-button type="primary" @click="saveRowData">{{ $t('common.btn.ok') }}</el-button>
        <el-button @click="cancelRowDataEditor">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUserInfo } from '@/utils/auth'
import URL from '@/api/urlTranslator'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getGridSelected, getGridSelectedIds } from '@/utils/agGrid'
import {
  getMailingAddressList, findMailingAddressByUuid, addMailingAddress, updateMailingAddress, batchDelMailingAddress
} from '@/api/partner/mailingAddress'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import CargoInput from '@/components/Cargo/Common/cargoInput.vue'
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  name: 'MailingAddress',
  components: { CargoInput, cargoAdvanceSelect },
  data() {
    const contactTypeDef = {
      shipperContactsTypes: [{
        value: 0,
        label: this.$t('baseInfo.mailingAddress.shipperPhoneNumber')
      }, {
        value: 1,
        label: this.$t('baseInfo.mailingAddress.shipperEmail')
      }, {
        value: 2,
        label: this.$t('baseInfo.mailingAddress.shipperFax')
      }],
      consigneeContactsTypes: [{
        value: 0,
        label: this.$t('baseInfo.mailingAddress.consigneePhoneNumber')
      }, {
        value: 1,
        label: this.$t('baseInfo.mailingAddress.consigneeEmail')
      }, {
        value: 2,
        label: this.$t('baseInfo.mailingAddress.consigneeFax')
      }],
      consigneeSpecificContactsTypes: [{
        value: 0,
        label: this.$t('baseInfo.mailingAddress.consigneeSpecificPhoneNumber')
      }, {
        value: 1,
        label: this.$t('baseInfo.mailingAddress.consigneeSpecificEmail')
      }, {
        value: 2,
        label: this.$t('baseInfo.mailingAddress.consigneeSpecificFax')
      }],
      notifyContactsTypes: [{
        value: 0,
        label: this.$t('baseInfo.mailingAddress.notifyPhoneNumber')
      }, {
        value: 1,
        label: this.$t('baseInfo.mailingAddress.notifyEmail')
      }, {
        value: 2,
        label: this.$t('baseInfo.mailingAddress.notifyFax')
      }],
      paymentContactsTypes: [{
        value: 0,
        label: this.$t('CargoMsg.Cargo_Payment4')
      }, {
        value: 1,
        label: this.$t('CargoMsg.Cargo_Payment5')
      }, {
        value: 2,
        label: this.$t('CargoMsg.Cargo_Payment6')
      }],
      paymentSpecificContactsTypes: [{
        value: 0,
        label: this.$t('baseInfo.mailingAddress.consigneeSpecificPhoneNumber')
      }, {
        value: 1,
        label: this.$t('baseInfo.mailingAddress.consigneeSpecificEmail')
      }, {
        value: 2,
        label: this.$t('baseInfo.mailingAddress.consigneeSpecificFax')
      }]
    }
    return {
      selectTypeNames: TYPE_NAMES,
      fullscreenLoading: null,
      searchConditions: {
        lob: '',
        partnerId: '',
        pod: '',
        shipperCode: '',
        consigneeCode: '',
        notifyCode: '',
        paymentCode: '',
        shipperName: '',
        consigneeName: '',
        notifyName: '',
        paymentName: '',
        pageNum: 1,
        pageSize: 10,
        total: 0,
        officeId: this.$store.getters.currentOfficeId,
        shipperLine1: '',
        consigneeLine1: '',
        notifyLine1: ''
      },
      podSelectOpt: {
        searchFormDisable: false,
        maintainFormDisable: false
      },
      itemTypeArray: [
        {
          value: 'QB',
          name: this.$t('constant.all')
        },
        ...this.$constantI18n('lobSource'),
        { name: this.$t('constant.systemConstants.IE'), value: 'IE' }
      ],
      gridParams: {},
      gridOptions: {
        rowHeight: 130,
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false
      },
      rowData: [],
      columnDefs: [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('baseInfo.mailingAddress.partner'),
          field: 'partnerId',
          cellRenderer: (params) => {
            if (params.data) {
              const chineseName = params.data['partnerChineseName']
              if (chineseName && chineseName.trim() !== '') {
                return chineseName
              }
              const englishName = params.data['partnerEnglishName']
              if (englishName && englishName.trim() !== '') {
                return englishName
              }
            }
            return ''
          }
        },
        {
          headerName: this.$t('baseInfo.mailingAddress.pod1'),
          field: 'pod',
          cellRenderer: (params) => {
            if (params.data) {
              const englishName = params.data['podEnglishName']
              if (englishName && englishName.trim() !== '') {
                return englishName
              }
            }
            return ''
          }
        },
        {
          headerName: this.$t('baseInfo.mailingAddress.lobType'),
          field: 'lob',
          cellRenderer: (params) => {
            if (params.value) {
              const type = this.$constantI18n('lobSource').find(item => {
                return item.value === params.value
              })
              return type ? type.name : params.value
            }
            return ''
          }
        },
        {
          headerName: this.$t('baseInfo.mailingAddress.shipperCode'),
          field: 'shipperCode'
        }, {
          headerName: this.$t('baseInfo.mailingAddress.ManifestFormatShipper'),
          hide: true,
          field: 'shipperInfoFormat',
          cellRenderer: (params) => CargoDocUtil.shipperAddressFormat(params.data, 'shipper')
        },
        {
          headerName: this.$t('baseInfo.mailingAddress.shipperInfo'),
          field: 'shipperInfo',
          cellRenderer: this.multipleDataRellRenderer
        },
        {
          headerName: this.$t('baseInfo.mailingAddress.consigneeCode'),
          field: 'consigneeCode'
        }, {
          headerName: this.$t('baseInfo.mailingAddress.TheManifestFormatConsignee'),
          hide: true,
          field: 'consigneeInfoFormat',
          cellRenderer: (params) => CargoDocUtil.consigneeAddressFormat(params.data, 'consignee')
        },
        {
          headerName: this.$t('baseInfo.mailingAddress.consigneeInfo'),
          field: 'consigneeInfo',
          cellRenderer: this.multipleDataRellRenderer
        },
        {
          headerName: this.$t('baseInfo.mailingAddress.notifyCode'),
          field: 'notifyCode'
        }, {
          headerName: this.$t('baseInfo.mailingAddress.ManifestFormatNotifier'),
          hide: true,
          field: 'notifyInfoFormat',
          cellRenderer: (params) => CargoDocUtil.notifyAddressFormat(params.data, 'notify')
        },
        {
          headerName: this.$t('baseInfo.mailingAddress.notifyInfo'),
          field: 'notifyInfo',
          cellRenderer: this.multipleDataRellRenderer
        },

        {
          headerName: this.$t('CargoMsg.Cargo_PaymentCode'),
          field: 'paymentCode'
        }, {
          headerName: this.$t('CargoMsg.Cargo_PaymentInfo'),
          hide: true,
          field: 'paymentInfoFormat',
          cellRenderer: (params) => CargoDocUtil.paymentAddressFormat(params.data, 'payment')
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PaymentInfo1'),
          field: 'paymentInfo',
          cellRenderer: this.multipleDataRellRenderer
        }],
      mailingAddressMaintainDialog: {
        isShow: false,
        isEdit: true,
        title: '',
        contactType: contactTypeDef
      },
      initMailingAddressForm: {
        officeId: '',
        lob: '',
        partnerId: '',
        pod: '',
        shipperCode: '',
        consigneeCode: '',
        notifyCode: '',
        // 发货人相关
        shipperShortCode: '',
        shipperEnterpriseCode: '',
        shipperEnterpriseName: '',
        shipperAddress: '',
        shipperContactsType: contactTypeDef.shipperContactsTypes[0].value,
        shipperContacts: '',
        shipperCityName: '',
        shipperProvinceCode: '',
        shipperProvinceName: '',
        shipperZipCode: '',
        shipperCountryCode: '',
        shipperAeoEnterpriseCode: '',
        shipperLine1: '',
        shipperLine2: '',
        shipperLine3: '',
        shipperLine4: '',
        shipperLine5: '',
        shipperLine6: '',
        shipperVipCode: '',
        shipperMscCode: '',
        shipperCompanyCode: '',
        shipperInttraCode: '',
        // 收货人相关
        instructBill: null,
        consigneeShortCode: '',
        consigneeEnterpriseCode: '',
        consigneeEnterpriseName: '',
        consigneeAddress: '',
        consigneeContactsType: contactTypeDef.consigneeContactsTypes[0].value,
        consigneeContacts: '',
        consigneeCityName: '',
        consigneeProvinceCode: '',
        consigneeProvinceName: '',
        consigneeZipCode: '',
        consigneeCountryCode: '',
        consigneeAeoEnterpriseCode: '',
        consigneeSpecificContactsType: contactTypeDef.consigneeSpecificContactsTypes[0].value,
        consigneeSpecificContactsName: '',
        consigneeSpecificContacts: '',
        consigneeLine1: '',
        consigneeLine2: '',
        consigneeLine3: '',
        consigneeLine4: '',
        consigneeLine5: '',
        consigneeLine6: '',
        consigneeVipCode: '',
        consigneeMscCode: '',
        consigneeCompanyCode: '',
        consigneeInttraCode: '',
        // 通知人相关
        notifyShortCode: '',
        notifyEnterpriseCode: '',
        notifyEnterpriseName: '',
        notifyAddress: '',
        notifyContactsType: contactTypeDef.notifyContactsTypes[0].value,
        notifyContacts: '',
        notifyCityName: '',
        notifyProvinceCode: '',
        notifyProvinceName: '',
        notifyZipCode: '',
        notifyCountryCode: '',
        notifyAeoEnterpriseCode: '',
        notifyLine1: '',
        notifyLine2: '',
        notifyLine3: '',
        notifyLine4: '',
        notifyLine5: '',
        notifyLine6: '',
        notifyVipCode: '',
        notifyMscCode: '',
        notifyCompanyCode: '',
        notifyInttraCode: '',
        // 付款方代码
        paymentInstructBill: null,
        paymentShortCode: '',
        paymentEnterpriseCode: '',
        paymentEnterpriseName: '',
        paymentAddress: '',
        paymentContactsType: contactTypeDef.paymentContactsTypes[0].value,
        paymentContacts: '',
        paymentCityName: '',
        paymentProvinceCode: '',
        paymentProvinceName: '',
        paymentZipCode: '',
        paymentCountryCode: '',
        paymentAeoEnterpriseCode: '',
        paymentSpecificContactsName: '',
        paymentEori: '',
        paymentStreetNo: '',
        paymentSpecificContactsType: contactTypeDef.paymentSpecificContactsTypes[0].value,
        paymentSpecificContacts: '',
        paymentLine1: '',
        paymentLine2: '',
        paymentLine3: '',
        paymentLine4: '',
        paymentLine5: '',
        paymentLine6: '',
        paymentVipCode: '',
        paymentMscCode: '',
        paymentCompanyCode: '',
        paymentInttraCode: ''
      },
      mailingAddressForm: null,
      isShowMailingAddressMaintain: false,
      formatManifestInfo: false,
      maintainDataRowPopEditor: {
        isShow: false,
        title: '',
        type: '',
        textData: ''
      },
      notUppercaseShipperConsigneNotify: true // CARGO-47047 收发通大小写控制
    }
  },
  computed: {
    url() {
      return URL
    },
    currentOfficeList() {
      return getUserInfo().currentUserOfficeList
    }
  },
  mounted() {
    this.fetchMailingAddressList()
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.notUppercaseShipperConsigneNotify = Number(cache.config.get('NotUppercaseShipperConsigneNotify')) !== 1
  },
  methods: {
    multipleDataRellRenderer(params) {
      if (params.value !== undefined) {
        return params.value.replace(/<br\/>/g, '<br/>')
      }
      return ''
    },
    getValueFromChild(model, obj) {
      model[obj.key] = obj.value
    },
    changeLob(formType, value) {
      this.podSelectOpt[formType] = (value === 'QB')
    },
    ladingBill(value) {
      this.mailingAddressForm.consigneeEnterpriseName = value ? 'TO ORDER' : ''
    },
    ladingPaymentBill(value) {
      this.mailingAddressForm.paymentEnterpriseName = value ? 'TO ORDER' : ''
    },
    toBatchDel() {
      const self = this
      getGridSelectedIds(this.gridOptions, 'uuid').then(ids => {
        if (ids.length < 1) {
          self.$message.error(self.$t('common.tips.hasOneAtleast'))
        }
        this.$confirm(this.$t('common.tips.confirmDelete'), this.$t('common.tips.confirm'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning'
        }).then(() => {
          batchDelMailingAddress(ids).then(res => {
            self.fetchMailingAddressList()
            this.$message.success(this.$t('common.tips.deleteSuccess'))
          })
        }).catch(() => {
          this.$message.info(this.$t('common.tips.cancelDelete'))
        })
      })
    },
    getMailingAddressSelected() {
      const selectedRows = this.gridOptions.api.getSelectedRows()
      if (selectedRows.length > 0) {
        return selectedRows
      }
      this.$message.error(this.$t('common.tips.hasOneAtleast'))
    },
    fetchMailingAddressList() {
      const self = this
      const params = { ...this.searchConditions }
      params.shipperLine1 = params.shipperName
      params.consigneeLine1 = params.consigneeName
      params.notifyLine1 = params.notifyName
      params.paymentLine1 = params.paymentName

      getMailingAddressList(params).then(res => {
        self.rowData = res.data.list
        this.searchConditions.pageNum = res.data.pageNum
        this.searchConditions.total = Number(res.data.total)
      })
    },
    popMailingAddressAddDialog() {
      this.mailingAddressForm = { ...this.initMailingAddressForm }
      this.mailingAddressMaintainDialog.isEdit = false
      this.mailingAddressMaintainDialog.title = this.$t('baseInfo.mailingAddress.addMailingAddress')
      this.mailingAddressMaintainDialog.isShow = true
    },
    syncFormatInfoToOrder(handleType) {
      switch (handleType) {
        case 'shipper':
          this.mailingAddressForm.shipperLine1 = this.mailingAddressForm.shipperEnterpriseCode
          this.mailingAddressForm.shipperLine2 = this.mailingAddressForm.shipperEnterpriseName
          this.mailingAddressForm.shipperLine3 = this.mailingAddressForm.shipperAddress
          this.mailingAddressForm.shipperLine4 = this.mailingAddressForm.shipperCityName +
            this.mailingAddressForm.shipperProvinceName +
            this.mailingAddressForm.shipperCountryCode +
            this.mailingAddressForm.shipperZipCode
          if (this.mailingAddressForm.shipperContacts) {
            this.mailingAddressForm.shipperLine5 = this.mailingAddressForm.shipperContactsType === 0
              ? ('TEL:' + this.mailingAddressForm.shipperContacts)
              : (this.mailingAddressForm.shipperContactsType === 1
                ? ('EMAIL:' + this.mailingAddressForm.shipperContacts)
                : ('FAX:' + this.mailingAddressForm.shipperContacts)
              )
          }
          break
        case 'consignee':
          this.mailingAddressForm.consigneeLine1 = this.mailingAddressForm.consigneeEnterpriseCode
          this.mailingAddressForm.consigneeLine2 = this.mailingAddressForm.consigneeEnterpriseName
          this.mailingAddressForm.consigneeLine3 = this.mailingAddressForm.consigneeAddress
          this.mailingAddressForm.consigneeLine4 = this.mailingAddressForm.consigneeCityName +
            this.mailingAddressForm.consigneeProvinceName +
            this.mailingAddressForm.consigneeCountryCode +
            this.mailingAddressForm.consigneeZipCode
          if (this.mailingAddressForm.consigneeContacts) {
            this.mailingAddressForm.consigneeLine5 = this.mailingAddressForm.consigneeContactsType === 0
              ? ('TEL:' + this.mailingAddressForm.consigneeContacts)
              : (this.mailingAddressForm.consigneeContactsType === 1
                ? ('EMAIL:' + this.mailingAddressForm.consigneeContacts)
                : ('FAX:' + this.mailingAddressForm.consigneeContacts)
              )
          }
          break
        case 'notify':
          this.mailingAddressForm.notifyLine1 = this.mailingAddressForm.notifyEnterpriseCode
          this.mailingAddressForm.notifyLine2 = this.mailingAddressForm.notifyEnterpriseName
          this.mailingAddressForm.notifyLine3 = this.mailingAddressForm.notifyAddress
          this.mailingAddressForm.notifyLine4 = this.mailingAddressForm.notifyCityName +
            this.mailingAddressForm.notifyProvinceName +
            this.mailingAddressForm.notifyCountryCode +
            this.mailingAddressForm.notifyZipCode
          if (this.mailingAddressForm.notifyContacts) {
            this.mailingAddressForm.notifyLine5 = this.mailingAddressForm.notifyContactsType === 0
              ? ('TEL:' + this.mailingAddressForm.notifyContacts)
              : (this.mailingAddressForm.notifyContactsType === 1
                ? ('EMAIL:' + this.mailingAddressForm.notifyContacts)
                : ('FAX:' + this.mailingAddressForm.notifyContacts)
              )
          }
          break
        case 'payment':
          this.mailingAddressForm.paymentLine1 = this.mailingAddressForm.paymentEnterpriseCode
          this.mailingAddressForm.paymentLine2 = this.mailingAddressForm.paymentEnterpriseName
          this.mailingAddressForm.paymentLine3 = this.mailingAddressForm.paymentAddress
          this.mailingAddressForm.paymentLine4 = this.mailingAddressForm.paymentCityName +
            this.mailingAddressForm.paymentProvinceName +
            this.mailingAddressForm.paymentCountryCode +
            this.mailingAddressForm.paymentZipCode
          if (this.mailingAddressForm.paymentContacts) {
            this.mailingAddressForm.paymentLine5 = this.mailingAddressForm.paymentContactsType === 0
              ? ('TEL:' + this.mailingAddressForm.paymentContacts)
              : (this.mailingAddressForm.paymentContactsType === 1
                ? ('EMAIL:' + this.mailingAddressForm.paymentContacts)
                : ('FAX:' + this.mailingAddressForm.paymentContacts)
              )
          }
          break
        default:
          break
      }
    },
    submitMailingAddress() {
      if (!this.checkMailingAddressForm()) {
        return
      }
      if (this.mailingAddressMaintainDialog.isEdit) {
        this.editMailingAddress()
      } else {
        this.mailingAddressForm.officeId = this.$store.getters.currentOfficeId
        this.saveMailingAddress()
      }
    },
    cancelSaveOrEdit() {
      this.mailingAddressMaintainDialog.isShow = false
      this.mailingAddressForm = { ...this.initMailingAddressForm }
    },
    saveMailingAddress() {
      this.fullscreenLoading = getLoading()
      addMailingAddress(this.mailingAddressForm).then(() => {
        this.mailingAddressMaintainDialog.isShow = false
        this.$message.success(this.$t('common.tips.saveSuccess'))
        this.fetchMailingAddressList()
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    popMailingAddressEditDialog() {
      const self = this
      getGridSelectedIds(this.gridOptions).then(ids => {
        if (ids.length !== 1) {
          self.$message.error(this.$t('common.tips.hasOneAtleast'))
        } else {
          console.log('getGridSelected(this.gridOptions)', getGridSelected(this.gridOptions)[0])
          const uuid = getGridSelected(this.gridOptions)[0].uuid
          findMailingAddressByUuid(uuid).then(result => {
            self.mailingAddressForm = { ...result.data }
            self.mailingAddressMaintainDialog.isEdit = true
            self.mailingAddressMaintainDialog.title = self.$t('baseInfo.mailingAddress.editMailingAddress')
            self.mailingAddressMaintainDialog.isShow = true
          }).finally(() => {
            self.fullscreenLoading.close()
          })
        }
      })
    },
    editMailingAddress() {
      this.fullscreenLoading = getLoading()
      updateMailingAddress(this.mailingAddressForm).then(() => {
        this.mailingAddressMaintainDialog.isShow = false
        this.$message.success(this.$t('common.tips.saveSuccess'))
        this.fetchMailingAddressList()
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    checkMailingAddressForm() {
      const { lob, instructBill, notifyEnterpriseCode, notifyContacts } = { ...this.mailingAddressForm }
      let errorMsg = ''
      if (!lob || !lob.trim()) {
        errorMsg += ' ' + this.$t('baseInfo.mailingAddress.validLobMsg')
      }
      if (instructBill) {
        if (!notifyEnterpriseCode || !notifyEnterpriseCode.trim() || !notifyContacts || !notifyContacts.trim()) {
          errorMsg += ' ' + this.$t('baseInfo.mailingAddress.validInstructBill')
        }
      }
      if (errorMsg === '') {
        return true
      }
      this.$message.error(errorMsg)
    },
    popRowDataEditor(type) {
      this.maintainDataRowPopEditor.type = type
      switch (type) {
        case 'shipper':
          this.maintainDataRowPopEditor.title = this.$t('baseInfo.mailingAddress.shipper')
          this.maintainDataRowPopEditor.textData = this.mailingAddressForm.shipperLine1 + '\n' +
            this.mailingAddressForm.shipperLine2 + '\n' +
            this.mailingAddressForm.shipperLine3 + '\n' +
            this.mailingAddressForm.shipperLine4 + '\n' +
            this.mailingAddressForm.shipperLine5 + '\n' +
            this.mailingAddressForm.shipperLine6
          break
        case 'consignee':
          this.maintainDataRowPopEditor.title = this.$t('baseInfo.mailingAddress.consignee')
          this.maintainDataRowPopEditor.textData = this.mailingAddressForm.consigneeLine1 + '\n' +
            this.mailingAddressForm.consigneeLine2 + '\n' +
            this.mailingAddressForm.consigneeLine3 + '\n' +
            this.mailingAddressForm.consigneeLine4 + '\n' +
            this.mailingAddressForm.consigneeLine5 + '\n' +
            this.mailingAddressForm.consigneeLine6
          break
        case 'notify':
          this.maintainDataRowPopEditor.title = this.$t('baseInfo.mailingAddress.notify')
          this.maintainDataRowPopEditor.textData = this.mailingAddressForm.notifyLine1 + '\n' +
            this.mailingAddressForm.notifyLine2 + '\n' +
            this.mailingAddressForm.notifyLine3 + '\n' +
            this.mailingAddressForm.notifyLine4 + '\n' +
            this.mailingAddressForm.notifyLine5 + '\n' +
            this.mailingAddressForm.notifyLine6
          break
        case 'payment':
          this.maintainDataRowPopEditor.title = this.$t('CargoMsg.Cargo_Payment1')
          this.maintainDataRowPopEditor.textData = this.mailingAddressForm.paymentLine1 + '\n' +
            this.mailingAddressForm.paymentLine2 + '\n' +
            this.mailingAddressForm.paymentLine3 + '\n' +
            this.mailingAddressForm.paymentLine4 + '\n' +
            this.mailingAddressForm.paymentLine5 + '\n' +
            this.mailingAddressForm.paymentLine6
          break
        default:
          break
      }
      this.maintainDataRowPopEditor.isShow = true
    },
    saveRowData() {
      const lines = this.maintainDataRowPopEditor.textData.split('\n')
      switch (this.maintainDataRowPopEditor.type) {
        case 'shipper':
          for (let i = 1; i < 7; i++) {
            this.mailingAddressForm['shipperLine' + i] = lines[i - 1] ? lines[i - 1] : ''
          }
          break
        case 'consignee':
          for (let i = 1; i < 7; i++) {
            this.mailingAddressForm['consigneeLine' + i] = lines[i - 1] ? lines[i - 1] : ''
          }
          break
        case 'notify':
          for (let i = 1; i < 7; i++) {
            this.mailingAddressForm['notifyLine' + i] = lines[i - 1] ? lines[i - 1] : ''
          }
          break
        default:
          break
      }
      this.maintainDataRowPopEditor.isShow = false
    },
    cancelRowDataEditor() {
      this.maintainDataRowPopEditor.isShow = false
    }
  }
}
</script>

<style lang="scss" scoped>
.mailing-address{
  .input-w{
    width: 280px!important;
  }
  .tag-w{
    width: 100%!important;
  }
  .prefix-input::before{
    content: '+';
    position: absolute;
    left: -10px;
  }
  .float-btn-wrapper{
    position: absolute;
    padding-bottom: 10px;
    bottom: 0;
  }
}
</style>
